// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import reactUpdate from 'immutability-helper';
import React from 'react';
import _ from 'underscore';

import {ValueLink} from 'constants/CRISPRConstants';
import GenomeSelector from 'molbio/genome/GenomeSelector';
import GenomeStore from 'stores/GenomeStore';
import Col from 'ui-library/bs/Col';
import FormGroup from 'ui-library/bs/FormGroup';
import Label from 'ui-library/bs/Label';
import Row from 'ui-library/bs/Row';

import PAMSelectorGroup from '../PAMSelectorGroup';

export interface Settings {
  genome: string;
  pam: string;
}

interface Props {
  settings: Settings;
  onChange: (settings: Settings) => void;
}

export default class SettingsForm extends React.Component<Props> {
  settingLink = <K extends keyof Settings>(key: K): ValueLink<Settings[K]> => ({
    value: this.props.settings[key],
    requestChange: (val: Settings[K]): void => {
      this.props.onChange(reactUpdate(this.props.settings, {$merge: _.object([[key, val]])}));
    },
  });

  override render(): JSX.Element {
    return (
      <div>
        <FormGroup>
          <Row>
            <Col className="text-right" sm={3}>
              <Label className="u-input-line-height">Genome</Label>
            </Col>
            <Col sm={8}>
              <GenomeSelector genomes={GenomeStore.getGenomes()} genomeLink={this.settingLink('genome')} />
            </Col>
          </Row>
        </FormGroup>
        <PAMSelectorGroup pamLink={this.settingLink('pam')} />
      </div>
    );
  }
}
